import { t } from "@/i18n-js/instance";
import { TRIGGER_RESOURCE_TYPE } from "../../../constants";
import type { EventOption } from "../types";
import { PaywallResource } from "./shared/PaywallResource";
import { WhichPaywallSelector } from "./shared/WhichPaywallSelector";

export const memberTrialConverted: Readonly<EventOption> = {
  label: t("workflows_v2.events.community_member_trial_converted.title"),
  value: "community_member_trial_converted",
  group: t("settings.workflows.form.event_groups.paywalls"),
  description: t(
    "workflows_v2.events.community_member_trial_converted.description",
  ),
  resource: TRIGGER_RESOURCE_TYPE.PAYWALL,
  formComponent: WhichPaywallSelector,
  viewComponent: PaywallResource,
  icon: "paywall",
};
